import React from 'react';

export interface SubtleTextProps extends React.HTMLAttributes<HTMLElement> {
    component?: React.ElementType<React.HTMLAttributes<HTMLElement>>;
}

export default function SubtleText({ component: Component = 'span', ...other }: SubtleTextProps) {
    return <Component className="subtle-text" {...other} />;
}
